import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'dva-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
})
export class NotificationDialogComponent implements OnInit {
  message: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) 
    public dialogData: {
      message: string;
    },
    private dialogRef: MatDialogRef<NotificationDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.message = this.dialogData.message;
  }

  close() {
    this.dialogRef.close();
  }
}
